import { call, put, takeLatest } from "redux-saga/effects";
import {
  getSectionStart,
  getSectionSuccess,
  getSectionFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { getSectionById } from "../../../services/section";

function* getSection({ payload }) {
  const { id } = payload;
  const response = yield call(getSectionById, id);
  const { success, raw, message } = response;

  if (success) {
    yield put(getSectionSuccess(raw));
  } else {
    yield put(getSectionFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onGetSection() {
  yield takeLatest(getSectionStart.type, getSection);
}
